export enum BasicDataParam {
  CRACK = 'crack',
  ET = 'et',
  BT = 'bt',
  POWER = 'heat',
  FAN = 'fan',
  TARGET = 'target',
  RPM = 'rpm',
  DRUM = 'drum_temp',
  INLET = 'inlet_temp',
  DRUM_PRESSURE = 'air_pressure',
  PCB_TEMP = 'pcb_temperature',
  PCB_HUMID = 'pcb_humidity',
}

export enum SensorconfigParam {
  TC0 = 'tc0',
  TC1 = 'tc1',
  TC2 = 'tc2',
  TC3 = 'tc3',
  TC4 = 'tc4',
  TC5 = 'tc5',
  TC6 = 'tc6',
  TC7 = 'tc7',
  TC8 = 'tc8',
  TC9 = 'tc9',
  TC10 = 'tc10',
  TC11 = 'tc11',
  TC12 = 'tc12',
  RTD0 = 'rtd0',
  RTD1 = 'rtd1',
  RTD2 = 'rtd2',
  RTD3 = 'rtd3',
  RTD4 = 'rtd4',
  RTD5 = 'rtd5',
  RTD6 = 'rtd6',
  RTD7 = 'rtd7',
  RTD8 = 'rtd8',
  RTD9 = 'rtd9',
  RTD10 = 'rtd10',
  RTD11 = 'rtd11',
}

// these values do not exist on Datapoints, or in the database. They are only used by frontend
export enum CalculatedDataParam {
  ROR = 'ror',
  ET_ROR = 'et_ror',
  EXT_ROR = 'ext_ror',
  TOTAL_CRACKS = 'total_cracks',
}

export type GraphDataParam = SensorconfigParam | BasicDataParam | CalculatedDataParam

export const GraphDataParamString = {
  [BasicDataParam.CRACK]: 'logview.cracks',
  [BasicDataParam.ET]: 'logview.airtemp',
  [BasicDataParam.BT]: 'logview.beantemp',
  [BasicDataParam.POWER]: 'logview.power',
  [BasicDataParam.FAN]: 'logview.fan',
  [BasicDataParam.TARGET]: 'logview.target',
  [BasicDataParam.RPM]: 'logview.chamberrpm',
  [BasicDataParam.DRUM]: 'logview.drumtemp',
  [BasicDataParam.INLET]: 'logview.inlettemp',
  [BasicDataParam.DRUM_PRESSURE]: 'logview.drumpressure',
  [BasicDataParam.PCB_TEMP]: 'logview.pcbtemp',
  [BasicDataParam.PCB_HUMID]: '',
  [SensorconfigParam.TC0]: '',
  [SensorconfigParam.TC1]: '',
  [SensorconfigParam.TC2]: '',
  [SensorconfigParam.TC3]: '',
  [SensorconfigParam.TC4]: '',
  [SensorconfigParam.TC5]: '',
  [SensorconfigParam.TC6]: '',
  [SensorconfigParam.TC7]: '',
  [SensorconfigParam.TC8]: '',
  [SensorconfigParam.TC9]: '',
  [SensorconfigParam.TC10]: '',
  [SensorconfigParam.TC11]: '',
  [SensorconfigParam.TC12]: '',
  [SensorconfigParam.RTD0]: '',
  [SensorconfigParam.RTD1]: '',
  [SensorconfigParam.RTD2]: '',
  [SensorconfigParam.RTD3]: '',
  [SensorconfigParam.RTD4]: '',
  [SensorconfigParam.RTD5]: '',
  [SensorconfigParam.RTD6]: '',
  [SensorconfigParam.RTD7]: '',
  [SensorconfigParam.RTD8]: '',
  [SensorconfigParam.RTD9]: '',
  [SensorconfigParam.RTD10]: '',
  [SensorconfigParam.RTD11]: '',
  [CalculatedDataParam.ROR]: 'logview.rateofrise',
  [CalculatedDataParam.ET_ROR]: 'logview.etror',
  [CalculatedDataParam.EXT_ROR]: 'logview.extror',
  [CalculatedDataParam.TOTAL_CRACKS]: 'logview.totalcracks',
}

export const GraphDataParamStringProfile = {
  [BasicDataParam.ET]: 'liveview.profileairtemp',
  [BasicDataParam.BT]: 'liveview.profilebeantemp',
  [BasicDataParam.POWER]: 'liveview.profilepower',
  [BasicDataParam.FAN]: 'liveview.profilefan',
  [BasicDataParam.RPM]: 'liveview.profilerpm',
  [BasicDataParam.INLET]: 'liveview.profileinlettemp',
}
